import { render, staticRenderFns } from "./stateCard.vue?vue&type=template&id=066c31c6&scoped=true"
import script from "./stateCard.vue?vue&type=script&lang=js"
export * from "./stateCard.vue?vue&type=script&lang=js"
import style0 from "./stateCard.vue?vue&type=style&index=0&id=066c31c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c31c6",
  null
  
)

export default component.exports